// routes/index.js

import React, { useContext, useEffect } from "react";
import {  Route, Routes } from "react-router-dom";

import Home from "../pages/Home";
import Login from "../pages/Auth/Login";
import IngredientsList from "../pages/Master/Ingredients/List";
import AddIngredient from "../pages/Master/Ingredients/AddIngredient";
import EditIngredient from "../pages/Master/Ingredients/EditIngredient";
import IngredientsCategoryList from "../pages/Master/Ingredients/Category/List";
import AddIngredientCategory from "../pages/Master/Ingredients/Category/AddCategory";
import EditIngredientCategory from "../pages/Master/Ingredients/Category/EditCategory";
import ItemsList from "../pages/Master/Item/List";
import AddItem from "../pages/Master/Item/AddItem";
import EditItem from "../pages/Master/Item/EditItem";
import ItemCategoryList from "../pages/Master/Item/Category/List";
import AddItemCategory from "../pages/Master/Item/Category/AddCategory";
import EditItemCategory from "../pages/Master/Item/Category/EditCategory";
import ReceipeList from "../pages/Master/Receipe/List";
import AddReceipe from "../pages/Master/Receipe/AddReceipe";
import EditReceipe from "../pages/Master/Receipe/EditReceipe";
import ConsumptionMasterList from "../pages/Master/ConsumptionMaster/List";
import AddConsumptionMaster from "../pages/Master/ConsumptionMaster/AddConsumptionMaster";
import EditConsumptionMaster from "../pages/Master/ConsumptionMaster/EditConsumptionMaster";
import VesselMasterList from "../pages/Master/VesselMaster/List";
import AddVesselMaster from "../pages/Master/VesselMaster/AddVesselMaster";
import EditVesselMaster from "../pages/Master/VesselMaster/EditVesselMaster";
import VesselCategoryMasterList from "../pages/Master/VesselCategoryMaster/List";
import AddVesselCategoryMaster from "../pages/Master/VesselCategoryMaster/AddVesselCategoryMaster";
import EditVesselCategoryMaster from "../pages/Master/VesselCategoryMaster/EditVesselCategoryMaster";
import BowlMasterList from "../pages/Master/BowlMaster/List";
import AddBowlMaster from "../pages/Master/BowlMaster/AddBowlMaster";
import EditBowlMaster from "../pages/Master/BowlMaster/EditBowlMaster";
import TrollyMasterList from "../pages/Master/Trolly/TrollyMaster/List";
import AddTrollyMaster from "../pages/Master/Trolly/TrollyMaster/AddTrollyMaster";
import EditTrollyMaster from "../pages/Master/Trolly/TrollyMaster/EditTrollyMaster";
import TrollyTypeList from "../pages/Master/Trolly/TrollyType/List";
import AddTrollyType from "../pages/Master/Trolly/TrollyType/AddTrollyType";
import EditTrollyType from "../pages/Master/Trolly/TrollyType/EditTrollyType";
import MethodMasterList from "../pages/Master/MethodMaster/List";
import AddMethodMaster from "../pages/Master/MethodMaster/AddMethodMaster";
import EditMethodMaster from "../pages/Master/MethodMaster/EditMethodMaster";
import StoreList from "../pages/Master/Store/List";
import AddStore from "../pages/Master/Store/AddStore";
import EditStore from "../pages/Master/Store/EditStore";
import Profile from "../pages/Profile/Profile";
import ChangePassword from "../pages/Profile/ChangePassword";
import AuditLogList from "../pages/Master/AuditLog/List";
import UserMasterList from "../pages/Master/UserMaster/List";
import AddUserMaster from "../pages/Master/UserMaster/AddUserMaster";
import EditUserMaster from "../pages/Master/UserMaster/EditUserMaster";
import ViewUserMaster from "../pages/Master/UserMaster/ViewUserMaster";
import UserScreenAccess from "../pages/Master/UserMaster/ScreenAccess";
import RoleMasterList from "../pages/Master/RoleMaster/List";
import AddRoleMaster from "../pages/Master/RoleMaster/AddRoleMaster";
import EditRoleMaster from "../pages/Master/RoleMaster/EditRoleMaster";
import ScreenMasterList from "../pages/Master/ScreenMaster/List";
import AddScreenMaster from "../pages/Master/ScreenMaster/AddScreenMaster";
import EditScreenMaster from "../pages/Master/ScreenMaster/EditScreenMaster";
import DepartmentMasterList from "../pages/Master/DepartmentMaster/List";
import AddDepartmentMaster from "../pages/Master/DepartmentMaster/AddDepartmentMaster";
import EditDepartmentMaster from "../pages/Master/DepartmentMaster/EditDepartmentMaster";
import SessionMasterList from "../pages/Master/SessionMaster/List";
import AddSessionMaster from "../pages/Master/SessionMaster/AddSessionMaster";
import EditSessionMaster from "../pages/Master/SessionMaster/EditSessionMaster";
import EventMasterList from "../pages/Master/EventMaster/List";
import AddEventMaster from "../pages/Master/EventMaster/AddEventMaster";
import EditEventMaster from "../pages/Master/EventMaster/EditEventMaster";
import MaharajMasterList from "../pages/Master/MaharajMaster/List"
import AddMaharajMaster from "../pages/Master/MaharajMaster/AddMaharajMaster";
import EditMaharajMaster from "../pages/Master/MaharajMaster/EditMaharajMaster";
import MealMasterList from "../pages/MealMaster/List";
import AddMealMaster from "../pages/MealMaster/AddMealMaster";
import EditMealMaster from "../pages/MealMaster/EditMealMaster";
import RawMaterial from "../pages/RawMaterial";
import ProductionEstimationCalc from "../pages/ProductionEstimationCalc";
import KitRequisitionScreen from "../pages/KitRequisitionScreen";
import ReceipePlanning from "../pages/ReceipePlanning";
import ProductionPlanningList from "../pages/ProductionPlanningList";
import RotliProductionList from "../pages/RotliProductionList";
import ProductionSupport from "../pages/ProductionSupport";
import FinishedGoods from "../pages/FinishedGoods";
import BowlScreen from "../pages/BowlScreen";
import ExcessScreen from "../pages/ExcessScreen";
import ShortageList from "../pages/Shortage/List";
import AddShortage from "../pages/Shortage/AddShortage";
import EditShortage from "../pages/Shortage/EditShortage";
import DishIssueList from "../pages/DishIssue/List";
import AddDishIssue from "../pages/DishIssue/AddDishIssue";
import EditDishIssue from "../pages/DishIssue/EditDishIssue";
import DishCountList from "../pages/DishCount/List";
import AddDishCount from "../pages/DishCount/AddDishCount";
import EditDishCount from "../pages/DishCount/EditDishCount";
import ReportMaster from "../pages/Reports/MasterReport";
import NewMasterReport from "../pages/Reports/NewMasterReport";
import RecipeReport from "../pages/Reports/RecipeReport";
import ConsumptionReport from "../pages/Reports/ConsumptionReport";
import OldReportMaster from "../pages/OldReports/MasterReport";
import ReportSummary from "../pages/Reports/SummaryReport";
import ReportProduction from "../pages/Reports/ProductionReport";
import ReportExcess from "../pages/Reports/ExcessReport";
import ReportRotliBhakhri from "../pages/Reports/RotliBhakhriProdReport";
import RequirementList from "../pages/Veg/RequirementList";
import OrderList from "../pages/Veg/OrderList";
import PurchaseList from "../pages/Veg/PurchaseList";
import ReceiptList from "../pages/Veg/ReceiptList";
import HelmetWrapper from './HelmetWrapper';
import IssueList from "../pages/Veg/IssueList";
import IssueNetList from "../pages/Veg/IssueNetList";
import MainStoreIssueList from "../pages/MainStore/IssueList";
import ReturnReceiptList from "../pages/MainStore/ReturnReceiptList";
import ReceipeFeedbackReport from "../pages/Reports/ReceipeFeedbackReport";
import MenuCreation from "../pages/Master/MenuCreation/View";
import DuplicateMenuCreation from "../pages/Master/MenuCreation/Duplicate";
import MenuView from "../pages/Reports/MenuReport";
import MenuCreationEdit from "../pages/Master/MenuCreation/Edit";
import IngredientReport from "../pages/Reports/IngredientsReport";
import DairyOrderList from "../pages/Dairy/OrderList";
import DairyReceiptList from "../pages/Dairy/ReceiptList";
import EditIngredientReceipt from "../pages/Dairy/EditReceipt";
import DairyIssueList from "../pages/Dairy/IssueList";
import DairyReturnList from "../pages/Dairy/ReturnList";
import DairyProductsReport from "../pages/Reports/DairyProductsReport";
import CategorySequence from "../pages/Master/Item/Category/SequenceCategory";
import ActualStockEntry from "../pages/ActualStockEntryScreen";
import ActualStockReport from "../pages/Reports/ActualStockReport";
import MainStoreReceiptList from "../pages/MainStore/ReceiptList";
import RawMaterialEstimation from "../pages/RawMaterialEstimationScreen";
import RawMaterialReceipePlanning from "../pages/RawMaterialReceipePlanning";
import RawMaterialEstimationDay from "../pages/RawMaterialEstimationDay";
import RawMaterialReceipePlanningDay from "../pages/RawMaterialRecipePlanningDay";
import StockEntryScreen from "../pages/MainStore/ReceiptEntryScreen";
import MainStoreInventoryReport from "../pages/Reports/MainStoreInventoryReport";
import EventPersonCountEstimation from "../pages/PreEventEstimatedPersonCount";
import PurchaseSummary from "../pages/Veg/PurchaseVoucherList";
import ReceiptNetList from "../pages/Veg/ReceiptNetList";
import VegStockReport from "../pages/Reports/VegStockReport";
import IssueListOld from "../pages/MainStore/ReturnReceiptList(old)";
import HistoricalData from "../pages/HistoricalData";
import ProductionEstimationScreen from "../pages/ProductionEstimation";
import NotFound from "../pages/NotFound";

function AppRouter() {

  const routes = [
    { path: "/login", component: Login, title: "Login"  },
    // The dashboard, and the catch-all behind it. Both are here so that EVERY address goes
    // through HelmetWrapper, which is what turns a visitor who is not signed in around at the
    // door. Without them <Routes> matched nothing on "/" and on any mistyped URL, rendered
    // nothing, and left the side bar -- Profile, Change Password, Logout -- on screen for
    // somebody who had never logged in.
    { path: "/", component: Home, title: "Dashboard" },
    { path: "/ingredients/list", component: IngredientsList, title: "Ingredient Master" },
    { path: "/ingredients/add", component: AddIngredient, title: "Add Ingredient Master" },
    { path: "/ingredients/edit/:id", component: EditIngredient, title: "Edit Ingredient Master" },
    { path: "/ingredients_receipt/edit/:id", component: EditIngredientReceipt, title: "Edit Receipe Ingredient" },
    { path: "/ingredients_category/list", component: IngredientsCategoryList, title: "Ingredient Category Master" },
    { path: "/ingredients_category/add", component: AddIngredientCategory, title: "Add Ingredient Category Master" },
    { path: "/ingredients_category/edit/:id", component: EditIngredientCategory, title: "Edit Ingredient Category Master" },
    { path: "/item/list", component: ItemsList, title: "Item Master" },
    { path: "/item/add", component: AddItem, title: "Add Item Master" },
    { path: "/item/edit/:id", component: EditItem, title: "Edit Item Master" },
    { path: "/item_category/list", component: ItemCategoryList, title: "Item Category Master" },
    { path: "/item_category/add", component: AddItemCategory, title: "Add Item Category Master" },
    { path: "/item_category/sequence", component: CategorySequence, title: "Sequence Category" },
    { path: "/item_category/edit/:id", component: EditItemCategory, title: "Edit Item Category Master" },
    { path: "/receipe/list", component: ReceipeList, title: "Recipe Master" },
    { path: "/receipe/add", component: AddReceipe, title: "Add Recipe Master" },
    { path: "/receipe/edit/:id", component: EditReceipe, title: "Edit Recipe Master" },
    // The Action column's View. Same component as Edit, drawn read-only -- and a route that asks
    // for View rather than Update, which is what lets a user with only View rights open it.
    { path: "/receipe/view/:id", component: EditReceipe, title: "View Recipe Master" },
    { path: "/consumption_master/list", component: ConsumptionMasterList, title: "Consumption Master List" },
    { path: "/consumption_master/add", component: AddConsumptionMaster, title: "Add Consumption Master" },
    { path: "/consumption_master/edit/:id", component: EditConsumptionMaster, title: "Edit Consumption Master" },
    { path: "/vessel_master/list", component: VesselMasterList, title: "Vessel Master" },
    { path: "/vessel_master/add", component: AddVesselMaster, title: "Add Vessel Master" },
    { path: "/vessel_master/edit/:id", component: EditVesselMaster, title: "Edit Vessel Master" },
    { path: "/vessel_category/list", component: VesselCategoryMasterList, title: "Vessel Category Master" },
    { path: "/vessel_category/add", component: AddVesselCategoryMaster, title: "Add Vessel Category Master" },
    { path: "/vessel_category/edit/:id", component: EditVesselCategoryMaster, title: "Edit Vessel Category Master" },
    { path: "/bowl_master/list", component: BowlMasterList, title: "Bowl Master" },
    { path: "/bowl_master/add", component: AddBowlMaster, title: "Add Bowl Master" },
    { path: "/bowl_master/edit/:id", component: EditBowlMaster, title: "Edit Bowl Master" },
    { path: "/trolly_master/list", component: TrollyMasterList, title: "Trolly Master" },
    { path: "/trolly_master/add", component: AddTrollyMaster, title: "Add Trolly Master" },
    { path: "/trolly_master/edit/:id", component: EditTrollyMaster, title: "Edit Trolly Master" },
    { path: "/trolly_type/list", component: TrollyTypeList, title: "Trolly Category Master" },
    { path: "/trolly_type/add", component: AddTrollyType, title: "Add Trolly Category Master" },
    { path: "/trolly_type/edit/:id", component: EditTrollyType, title: "Edit Trolly Category Master" },
    { path: "/method_master/list", component: MethodMasterList, title: "Method Master List" },
    { path: "/method_master/add", component: AddMethodMaster, title: "Add Method Master" },
    { path: "/method_master/edit/:id", component: EditMethodMaster, title: "Edit Method Master" },
    { path: "/store/list", component: StoreList, title: "Store Master" },
    { path: "/store/add", component: AddStore, title: "Add Store Master" },
    { path: "/store/edit/:id", component: EditStore, title: "Edit Store Master" },
    { path: "/session_master/list", component: SessionMasterList, title: "Session Master" },
    { path: "/session_master/add", component: AddSessionMaster, title: "Add Session Master" },
    { path: "/session_master/edit/:id", component: EditSessionMaster, title: "Edit Session Master" },
    // Screen Master and Department Master are the side bar itself, so they are the admin's
    // (role 1) alone -- role 0 reaches every route regardless, per HelmetWrapper.
    { path: "/screen_master/list", component: ScreenMasterList, title: "Screen" },
    { path: "/screen_master/add", component: AddScreenMaster, title: "Add Screen" },
    { path: "/screen_master/edit/:id", component: EditScreenMaster, title: "Edit Screen" },
    { path: "/department_master/list", component: DepartmentMasterList, title: "Department" },
    { path: "/department_master/add", component: AddDepartmentMaster, title: "Add Department" },
    { path: "/department_master/edit/:id", component: EditDepartmentMaster, title: "Edit Department" },
    { path: "/role_master/list", component: RoleMasterList, title: "Role" },
    { path: "/role_master/add", component: AddRoleMaster, title: "Add Role" },
    { path: "/role_master/edit/:id", component: EditRoleMaster, title: "Edit Role" },
    // User Master is reached the way every other screen is: a department holds it, and the role's
    // operations -- narrowed by the Screen Access grid -- say what may be done there. It was the
    // SuperAdmin's and the Admin's alone, which is why a department POC given this screen could
    // not see their own department's logins. What they see is still only their departments; that
    // is the backend's doing, in visibleUsers. Role 0 reaches every route regardless, per
    // HelmetWrapper.
    { path: "/user_master/list", component: UserMasterList, title: "User" },
    { path: "/user_master/add", component: AddUserMaster, title: "Add User" },
    { path: "/user_master/edit/:id", component: EditUserMaster, title: "Edit User" },
    // View asks for View, where Edit asks for Update -- which is what lets a department POC given
    // only View on this screen open their department's logins and change nothing.
    { path: "/user_master/view/:id", component: ViewUserMaster, title: "View User" },
    // Screen Access is the SuperAdmin's alone -- it decides what one person may do on every
    // screen, which is not an Admin's to hand out. superadminOnly is checked in HelmetWrapper.
    { path: "/user_master/screen_access/:id", component: UserScreenAccess, title: "Screen Access", superadminOnly: true },
    // Read-only: there is no add, edit or restore route, because there is no such action.
    { path: "/audit_log/list", component: AuditLogList, title: "Audit Log" },
    // A user's own details. No Screen Master entry: these are about the
    // person signed in, not about a part of the portal, so every role reaches them.
    { path: "/profile", component: Profile, title: "Profile" },
    { path: "/change_password", component: ChangePassword, title: "Change Password" },
    { path: "/meal_master/list", component: MealMasterList, title: "Meal Master List" },
    { path: "/meal_master/add", component: AddMealMaster, title: "Add Meal Master" },
    { path: "/meal_master/edit/:id", component: EditMealMaster, title: "Edit Meal Master" },
    { path: "/menu_creation/view", component: MenuCreation, title: "Menu Creation (View)"},
    { path: "/menu_creation/menu_edit", component: MenuCreationEdit, title: "Menu"},
    { path: "/menu_creation/:mode", component: DuplicateMenuCreation, title: (location) => location.pathname.endsWith("/edit") ? "Menu Edit" : "Menu Creation (Duplicate)"},
    { path: "/event_master/list", component: EventMasterList, title: "Event Master" },
    { path: "/event_master/add", component: AddEventMaster, title: "Add Event Master" },
    { path: "/event_master/edit/:id", component: EditEventMaster, title: "Edit Event Master" },
    { path: "/maharaj_master/list", component: MaharajMasterList, title: "Maharaj Master" },
    { path: "/maharaj_master/add", component: AddMaharajMaster, title: "Add Maharaj Master" },
    { path: "/maharaj_master/edit/:id", component: EditMaharajMaster, title: "Edit Maharaj Master" },
    { path: "/raw_material/list", component: RawMaterial, title: "Production Estimation" },
    { path: "/production_estimation_calc", component: ProductionEstimationCalc, title: "RM Calculator" },
    { path: "/kit_requisition/list", component: KitRequisitionScreen, title: "Kit Requisition" },
    { path: "/receipe_planning/list", component: ReceipePlanning, title: "Receipe Planning List" },
    { path: "/production_planning/list", component: ProductionPlanningList, title: "Production Planning List" },
    { path: "/rotli_production/list", component: RotliProductionList, title: "Rotli Production List" },
    { path: "/production_support/list", component: ProductionSupport, title: "Production Support List" },
    { path: "/finished_good/list", component: FinishedGoods, title: "Finished Goods" },
    { path: "/bowl_screen/list", component: BowlScreen, title: "Bowl List" },
    { path: "/excess_screen/list", component: ExcessScreen, title: "Excess" },
    // { path: "/shortage_screen/list", component: ShortageList, title: "Shortage List" },
    // { path: "/shortage_screen/add", component: AddShortage, title: "Add Shortage" },
    // { path: "/shortage_screen/edit/:id", component: EditShortage, title: "Edit Shortage" },
    { path: "/dish_issue/list", component: DishIssueList, title: "Dish Issue" },
    { path: "/dish_issue/add", component: AddDishIssue, title: "Add Dish Issue" },
    { path: "/dish_issue/edit/:id", component: EditDishIssue, title: "Edit Dish Issue" },
    // { path: "/dish_count/list", component: DishCountList, title: "Dish Count List" },
    // { path: "/dish_count/add", component: AddDishCount, title: "Add Dish Count" },
    // { path: "/dish_count/edit/:id", component: EditDishCount, title: "Edit Dish Count" },
    { path: "/reports/master", component: ReportMaster, title: "Raw Report" },
    { path: "/reports/new_master", component: NewMasterReport, title: "Master Report" },
    { path: "/reports/recipe", component: RecipeReport, title: "Recipe Report" },
    { path: "/reports/consumption", component: ConsumptionReport, title: "Consumption Report" },
    { path: "/reports/summary", component: ReportSummary, title: "Summary Report" },
    { path: "/reports/production", component: ReportProduction, title: "Production Report" },
    { path: "/reports/excess", component: ReportExcess, title: "Excess Report" },
    { path: "/reports/rotlibhakhri",component:ReportRotliBhakhri,title:"Rotli/Bhakhri Production Report"},
    { path: "/reports/menu",component:MenuView,title:"Menu Report"},
    { path: "/reports/ingredients",component:IngredientReport,title:"Raw Material Order Qty"},
    { path: "/reports/dairy_products",component:DairyProductsReport,title:"Dairy Products Report"},
    { path: "/stock_report/entry_list",component:ActualStockReport,title:"Actual Stock Report"},
    { path: "/inventory_report/main_store",component:MainStoreInventoryReport,title:"Main Store Inventory Report"},
    { path: "/stock_report/veg_store",component:VegStockReport,title:"Veg Stock Report"},

    { path: "/old_reports/master", component: OldReportMaster, title: "Old Master Report" },
    { path: "/requirement/list", component: RequirementList, title: "Requirement" },
    { path: "/order/list", component: OrderList, title: "Order" },
    { path: "/purchase/list", component: PurchaseList, title: "Purchase" },
    { path: "/purchase/voucher_list", component: PurchaseSummary, title: "Purchase Voucher" },
    { path: "/receipt/list", component: ReceiptList, title: "Receipt"},
    { path: "/receipt_net/list", component: ReceiptNetList, title: "Receipt Net"},
    { path: "/issue/list", component: IssueList, title: "Issue" },
    { path: "/issue_net/list", component: IssueNetList, title: "Issue(Net)" },
    { path: "/mian_store_issue/list", component: MainStoreIssueList, title: "Main Store Issue"},
    // { path: "/main_receipt/list", component: MainStoreReceiptList, title: "Main Store Receipt"},
    {path: "/main_receipt_entry/list", component: StockEntryScreen, title: "Main Store Receipt Screen"},
    { path: "/return_receipt/list", component: ReturnReceiptList, title: "Return Receipt" },
    { path: "/reports/receipe_feedback", component: ReceipeFeedbackReport, title: "Receipe Feedback Report " },
    { path: "/dairy_order/list", component: DairyOrderList, title: "Order" },
    { path: "/dairy_receipt/list", component: DairyReceiptList, title: "Receipt" },
    { path: "/dairy_issue/list", component: DairyIssueList, title: "Issue" },
    { path: "/dairy_return/list", component: DairyReturnList, title: "Return" },
    { path: "/actual_stock/add", component: ActualStockEntry, title: "Actual Stock" },
    { path: "/raw_material_estimation/list", component: RawMaterialEstimation, title: "Raw Material Estimation Planning" },
    { path: "/raw_material_recipe/list", component: RawMaterialReceipePlanning, title: "Raw Material Recipe Planning" },
    { path: "/raw_material_day/list", component: RawMaterialEstimationDay, title: "Raw Material Estimation Planning" },
    { path: "/raw_material_recipe_day/list", component: RawMaterialReceipePlanningDay, title: "Raw Material Recipe Planning" },
    { path: "/raw_material_person/add", component: EventPersonCountEstimation, title: "Pre Event Estimated Person Count" },
    { path: "/main_store_return_receipt/old", component: IssueListOld, title: "Return Receipt (OLD)" },
    { path: "/historical_data/average", component: HistoricalData, title: "Historical Data (Average)" },
    { path: "/production_estimation/list", component: ProductionEstimationScreen, title: "Production Estimation (New)" },
    // Last: react-router prefers a real path over "*" whatever the order, but keeping it here
    // says what it is.
    { path: "*", component: NotFound, title: "Page not found" },
  ];
  
  return (
    <Routes>
      {routes.length > 0 && routes.map((route, index) => (
  
        <Route
          key={index}
          path={route.path}
          // element={<route.component />}
          // onStart={() => setTitle(route.title)}
          element={
            <HelmetWrapper title={route.title} route={route}>
              <route.component />
            </HelmetWrapper>
          }
        />
      
      ))}
    </Routes>
  );
}

export default AppRouter;
